var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"result-images-type-container"},[(_vm.items.length > 0)?_c('ImageSlide',{attrs:{"images":_vm.items,"mini":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }